import { render, staticRenderFns } from "./TurkishLocationPicker.vue?vue&type=template&id=a227e2fe"
import script from "./TurkishLocationPicker.vue?vue&type=script&lang=js"
export * from "./TurkishLocationPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports